// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Flavor$LiteracyplanetTupperware from "./Flavor.res.mjs";

function StemHeading(props) {
  return React.createElement("div", {
              className: Flavor$LiteracyplanetTupperware.StemHeading.className
            }, props.children);
}

var make = StemHeading;

var $$default = StemHeading;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
